import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import moment from 'moment';
import { GET_TITLE_BY_EDITOR_ID } from '../../../queries/titleEditor';
import ListTitles from './ListTitles';
import HeaderTitles from './HeaderTitles';
import { usePermissions } from '../../../store/permissions.context';
import Layout from '../../../components/Layout/Layout';

export default function QueryTitlesEditor() {
  const [permissions, setPermissions] = usePermissions();
  const [titles, setTitles] = useState([]);
  const [isByPublishPost, setIsByPublishPost] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(
    moment().add(-6, 'days').startOf('day').toDate(),
  );
  const [selectedEndDate, setSelectedEndDate] = useState(
    moment().endOf('day').toDate(),
  );
  const [dateTypeFilter, setDateTypeFilter] = useState('Last7Days');

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(10);
  const [filterSearchText, setFilterSearchText] = useState(null);
  const [filterStatus, setFilterStatus] = useState(null);
  const [statusCanBeOpened, setStatusCanBeOpened] = useState([]);

  const queryTitles = useQuery(GET_TITLE_BY_EDITOR_ID, {
    variables: {
      offset: page * limit,
      limit,
      dateStart: selectedStartDate,
      dateEnd: selectedEndDate,
      searchText: filterSearchText,
      status: filterStatus,
      byPublishPost: isByPublishPost,
    },
    fetchPolicy: 'network-only',
  });

  const { loading, error, refetch } = queryTitles;
  const refetchTitles = async () => {
    return queryTitles.refetch();
  };
  useEffect(() => {
    if (queryTitles.data) {
      const {
        data: {
          titlesAsEditor: { titles, permissions, total },
        },
      } = queryTitles;
      setTitles(titles);
      setTotal(total);
      setPermissions(permissions);
      setStatusCanBeOpened(permissions.statusCanBeOpened);
    }
  }, [queryTitles, setPermissions]);

  return (
    <Layout>
      <HeaderTitles
        titles={titles}
        filterStatus={filterStatus}
        setFilterStatus={setFilterStatus}
        isByPublishPost={isByPublishPost}
        setIsByPublishPost={setIsByPublishPost}
        selectedStartDate={selectedStartDate}
        setSelectedStartDate={setSelectedStartDate}
        selectedEndDate={selectedEndDate}
        setSelectedEndDate={setSelectedEndDate}
        setPage={setPage}
        dateTypeFilter={dateTypeFilter}
        setDateTypeFilter={setDateTypeFilter}
        refetchTitles={refetchTitles}
        permissions={permissions}
      />
      <ListTitles
        titles={titles}
        setTitles={setTitles}
        total={total}
        loading={loading}
        error={error}
        refetch={refetch}
        refetchTitles={refetchTitles}
        setFilterSearchText={setFilterSearchText}
        setLimit={setLimit}
        setPage={setPage}
        limit={limit}
        page={page}
        fieldsNotShow={['writerId']}
        statusCanBeOpened={statusCanBeOpened}
      />
    </Layout>
  );
}
